<template>
    <div>
        <div class="card card-default">
            <div class="border-b-2 border-followup-nav py-2 pl-4 text-grey-darkest text-sm font-weight-bold">Default Activities Settings</div>

            <div class="card-body">
                <div class="container">
                    <div class="row">
                        <div class="col">
                            <label class="text-sm text-grey-darkest">Filter by Fixed Date</label>
                            <multiselect :options="dateRanges"
                                v-model="selectedFixedDateRangeIdentifier"
                                :show-labels="false"
                                @input="setFixedDateRange(selectedFixedDateRangeIdentifier)"
                                @remove="clearDates"
                                track-by="id" label="name" class="mb-2 cursor-pointer">
                            </multiselect>
                        </div>

                        <div class="col">
                            <div class="flex">
                                <v-date-picker v-model="selectedDateRange" is-range :masks="rangeMask" @input="setFixedDateRange({id:0})" :popover="{ visibility: 'click' }">
                                    <template v-slot="{ inputValue, inputEvents }">
                                        <div class="flex w-full">
                                            <div class="flex-column mr-2">
                                                <label class="text-sm text-grey-darkest">Start Date</label>
                                                <input
                                                    :value="inputValue.start"
                                                    v-on="inputEvents.start"
                                                    class=" mr-1 cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l rounded-r text-grey-darkest text-sm w-full"
                                                />
                                            </div>
                                            <div class="flex-column">
                                                <label class="text-sm text-grey-darkest">End Date</label>
                                                <input
                                                    :value="inputValue.end"
                                                    v-on="inputEvents.end"
                                                    class="cursor-pointer date-picker-input border-1 border-grey focus:outline-none px-2 rounded-l text-grey-darkest text-sm w-full"
                                                />
                                            </div>
                                        </div>
                                    </template>
                                </v-date-picker>
                                <div class="flex-column">
                                    <label class="text-sm text-grey-darkest"></label>
                                    <div
                                        class="-ml-0 border-b-1 border-grey border-r-1 border-t-1 cursor-pointer flex hover:bg-grey hover:text-white text-grey-darkest items-center px-2 rounded-r cross-btn"
                                        @click.stop="clearDates">
                                        <i class="material-icons text-sm">clear</i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col">
                            <label class="text-sm text-grey-darkest">Filter by User</label>
                            <multiselect
                                :options="users"
                                v-model="selectedUsers"
                                :show-labels="false"
                                track-by="id"
                                label="name"
                                :multiple="true"
                                class="cursor-pointer">
                            </multiselect>
                        </div>

                        <div class="col">
                            <label class="text-sm text-grey-darkest">Filter by Office</label>
                            <multiselect
                                :options="offices"
                                v-model="selectedOffices"
                                :show-labels="false"
                                track-by="id"
                                group-values="offices"
                                group-label="label"
                                :group-select="true"
                                label="code"
                                :multiple="true"
                                class="cursor-pointer">
                            </multiselect>
                        </div>

                        <div class="col">
                            <label class="text-sm text-grey-darkest">Filter by Contract Type</label>
                            <multiselect
                                :options="contractTypes"
                                v-model="selectedContractTypes"
                                :show-labels="false"
                                track-by="id"
                                group-values="contractTypes"
                                group-label="label"
                                :group-select="true"
                                label="code"
                                :multiple="true"
                                class="cursor-pointer">
                            </multiselect>
                        </div>
                    </div>

                    <div class="row mt-4">
                        <div class="col">
                            <button class="py-2 mr-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded-full text-followup-nav"
                                @click="makeDefault" type="button">
                                Make Default
                            </button>

                            <button class="py-2 focus:outline-none border-1 border-followup-nav hover:bg-followup-nav hover:text-white px-10 md:px-3 rounded-full text-followup-nav"
                                @click="clearDefault" type="button">
                                Clear Default
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Datepicker from 'vuejs-datepicker';
import Multiselect from 'vue-multiselect';
import moment from "moment";

export default {
    name: 'default-dashboard-settings',

    components: { Datepicker, Multiselect },

    data() {
        return {
            rangeMask: {
                input: null,
            },
            dateRanges: [],
            selectedDateRange: this.dateRange ? {
                start: moment(this.dateRange.start).format('MM/DD/YYYY'),
                end: moment(this.dateRange.end).format('MM/DD/YYYY')
            } : null,
            selectedFixedDateRangeIdentifier: this.fixedDateRangeIdentifier !== null ? this.fixedDateRangeIdentifier : null,
            offices: [
                {
                    label: 'All',
                    offices:[],
                }
            ],
            contractTypes: [
                {
                    label: 'All',
                    contractTypes:[],
                }
            ],
            selectedOffices: [],
            selectedContractTypes: [],
            users: [],
            selectedUsers: [],
        }
    },
    created(){
        this.getDefaultData();
    },

    methods: {
        getDefaultData() {
            let self = this;
            axios.get(route('settings.get-dashboard-default-data')).then((response) => {
                if(response.data.status === 1) {

                    self.dateRanges = response.data.dateRanges;
                    self.users = response.data.allUsers;
                    self.offices[0].offices = [...response.data.allOffices];
                    self.contractTypes[0].contractTypes = [...response.data.allContractTypes];
                    this.setFixedDateRange(response.data.selectedFixedDateRangeIdentifier)

                    if(response.data.startDate !== null && response.data.endDate !== null && response.data.selectedFixedDateRangeIdentifier === 0) {
                        self.selectedDateRange = {
                            start: moment(response.data.startDate).format('MM/DD/YYYY'),
                            end: moment(response.data.endDate).format('MM/DD/YYYY'),
                        };
                    }

                    self.selectedFixedDateRangeIdentifier = response.data.selectedFixedDateRangeIdentifier;

                    let users = response.data.selectedUsers;
                    if(users != null) {
                        if(users.length === 1 && users[0] === 0) {
                            self.selectedUsers = [{
                                id: 0,
                                name: 'Company'
                            }];
                        } else {
                            let userIds = users;
                            self.selectedUsers = self.users.filter((element) => {
                                return userIds.find((aux) => aux === element.id);
                            });
                        }
                    }

                    let office = response.data.selectedOffices;
                    if(office) {
                        self.selectedOffices = self.offices[0].offices.filter((element) => {
                            return office.find((aux) => aux == element.id);
                        });
                    }

                    let contract = response.data.selectedContractTypes;;
                    if(contract) {
                        self.selectedContractTypes = self.contractTypes[0].contractTypes.filter((element) => {
                            return contract.find((aux) => aux == element.id);
                        });
                    }

                    self.rangeMask = {
                        input: response.data.masks.moment_mask,
                    };
                }
            });
        },

        clearDates() {
            this.selectedDateRange = null;
        },

        makeDefault() {
            let self = this;
            let filterObject = {
                'start_date': null,
                'end_date': null,
                'fixed_date_range_identifier': null,
                'user': null,
                'contract_type': null,
                'office': null,
            };

            if(self.selectedDateRange) {
                filterObject.start_date = moment(self.selectedDateRange.start).format('l');
                filterObject.end_date = moment(self.selectedDateRange.end).format('l');
            }

            if(self.selectedFixedDateRangeIdentifier) {
                filterObject.fixed_date_range_identifier = self.selectedFixedDateRangeIdentifier.id;
            }

            if(self.selectedUsers) {
                let companyExist = self.selectedUsers.find(user => user.id === 0);

                if(companyExist) {
                    filterObject.user = JSON.stringify([companyExist.id]);
                } else {
                    filterObject.user = JSON.stringify(this.selectedUsers.map((user) => user.id));
                }
            }

            if(self.selectedContractTypes) {
                filterObject.contract_type = JSON.stringify(self.selectedContractTypes.map((office)=>office.id));
            }

            if(self.selectedOffices) {
                filterObject.office = JSON.stringify(self.selectedOffices.map((office)=>office.id));
            }

            axios.post(route('settings.store-dashboard-default-settings'), {filter_object: filterObject}).then((data) => {
                if(data.data.status === 1) {
                    this.getToast().fire({
                        type: 'success',
                        title: data.data.message
                    });
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong!'
                    });
                }
            });
        },

        setFixedDateRange(dateRange) {
            if (!dateRange) return;

            this.selectedFixedDateRangeIdentifier = this.dateRanges[dateRange.id];

            if(dateRange.id > 0)
            this.selectedDateRange = {
                start: moment(this.dateRanges[dateRange.id].startDate).format('MM/DD/YYYY'),
                end: moment(this.dateRanges[dateRange.id].endDate).format('MM/DD/YYYY')
            };
        },

        clearDefault() {
            axios.get(route('settings.clear-dashboard-default-settings')).then((data) => {
                if(data.data.status === 1) {
                    this.getToast().fire({
                        type: 'success',
                        title: data.data.message
                    });
                    this.getDefaultData();
                } else {
                    this.getToast().fire({
                        type: 'error',
                        title: 'Something went wrong!'
                    });
                }
            });
        }
    }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
    .date-picker-input {
        padding: .61rem .5rem !important;
    }
    .cross-btn {
        height: 38px;
        margin-top: 7px;
    }
</style>
